import Loader from "pages/Loader"
import PermittedComponent from "PermittedComponent"
import React, { useEffect, useState } from "react"
import { Container, Label } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { usePermissionData } from "AppContext"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { FaChevronLeft, FaRupeeSign, FaSave } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { notification } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"

const Addpayout = () => {
  const { checkAccess } = usePermissionData()
  const navigate = useNavigate()

  const [Loading, setLoading] = useState(false)
  const [Customers, setCustomers] = useState([])
  const [formData, setFormData] = useState({
    customerId: "",
    VoucherNo: "",
    Date: "",
    Particulars: "",
    paymentAmount: "",
    ChqNo: "",
    Type: "", // <-- Added
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`customer-management`)
      if (response?.data?.success) {
        setCustomers(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const validate = () => {
    let newErrors = {}
    if (!formData.customerId) newErrors.customerId = "Customer is required"
    if (!formData.VoucherNo.trim())
      newErrors.VoucherNo = "Voucher number is required"
    if (!formData.Date)
      newErrors.Date = "Payment date is required"
    if (!formData.Particulars.trim())
      newErrors.Particulars = "Description is required"
    if (!formData.paymentAmount || isNaN(formData.paymentAmount))
      newErrors.paymentAmount = "Valid amount is required"
    if (!formData.Type)
      newErrors.Type = "Voucher type is required"
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validate()) return

    try {
      setLoading(true)
      const response = await axiosbaseurl.post("/payments", formData)
      if (response?.data?.success) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">
                Payment Created Successfully.
              </div>
            </div>
          ),
          placement: "topRight",
        })

        setTimeout(() => {
          navigate(`${ConfigUrl.appurl}payouts`)
        }, 1000)
      } else {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      setLoading(false)
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(10, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Payout" breadcrumbItem="Add Payout" />

            <div className="card p-3">
              <div className="text-end mt-3">
                <button
                  className="btn edit-Button bg-success text-white me-3 rounded-5"
                  onClick={handleSubmit}
                >
                  <FaSave className="me-2" />
                  Submit
                </button>
                <button
                  className="btn delete-Button rounded-5"
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft className="me-2" />
                  Back
                </button>
              </div>
              <div className="Line mb-3" />

              <div className="row">
                <div className="col-xl-6">
                  <Label className="text-muted ps-1 fs-6 fw-medium">
                    Customer <span className="text-danger">*</span>
                  </Label>
                  <select
                    className="form-control"
                    name="customerId"
                    value={formData.customerId}
                    onChange={handleChange}
                  >
                    <option value="">Select Customer</option>
                    {Customers?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.customerName}
                      </option>
                    ))}
                  </select>
                  {errors.customerId && (
                    <span className="text-danger">{errors.customerId}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12">
                  <label>
                    Voucher Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="VoucherNo"
                    value={formData.VoucherNo}
                    onChange={handleChange}
                  />
                  {errors.VoucherNo && (
                    <span className="text-danger">{errors.VoucherNo}</span>
                  )}
                </div>
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Voucher Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="Type"
                    value={formData.Type}
                    onChange={handleChange}
                  >
                    <option value="">Select Type</option>
                    <option value="RECEIPT">Receipt</option>
                    <option value="PAYMENT">Payment</option>
                  </select>
                  {errors.Type && (
                    <span className="text-danger">{errors.Type}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Payment Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="Date"
                    value={formData.Date}
                    onChange={handleChange}
                  />
                  {errors.Date && (
                    <span className="text-danger">{errors.Date}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Payment Amount <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <FaRupeeSign />
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      name="paymentAmount"
                      value={formData.paymentAmount}
                      onChange={handleChange}
                    />
                    {errors.paymentAmount && (
                      <span className="text-danger">
                        {errors.paymentAmount}
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Cheque No.
                  </label>
                  <input
                    className="form-control"
                    name="ChqNo"
                    value={formData.ChqNo}
                    onChange={handleChange}
                  >
                  </input>
                  {errors.ChqNo && (
                    <span className="text-danger">{errors.ChqNo}</span>
                  )}
                </div>

                <div className="form-group col-12 mt-3">
                  <label>
                    Payment Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="Particulars"
                    value={formData.Particulars}
                    onChange={handleChange}
                  />
                  {errors.Particulars && (
                    <span className="text-danger">
                      {errors.Particulars}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Addpayout
